import { AddRoundedIcon, Button, type ButtonProps } from '@shared/components';
import { useDisclosure } from '@shared/hooks';

import { ExamAssigningModal } from '../exam-assigning-modal';

type ExamAssigningButtonProps = Pick<ButtonProps, 'variant'>;

export default function ExamAssigningButton(props: Readonly<ExamAssigningButtonProps>) {
  const { variant = 'contained' } = props;

  const [isOpen, examAssigningModalHandler] = useDisclosure();
  const { open: openExamAssigningModal, close: closeExamAssigningModal } =
    examAssigningModalHandler;

  return (
    <>
      <Button
        size='large'
        variant={variant}
        startIcon={<AddRoundedIcon />}
        onClick={openExamAssigningModal}
      >
        Assign Exam
      </Button>
      {isOpen ? <ExamAssigningModal open={isOpen} onClose={closeExamAssigningModal} /> : null}
    </>
  );
}
